'use strict'

define ['./bank_account.css'], () ->
  ($scope, $http, RentappService, RENTAPPLICATION_API_URL, $state, Flash, $cacheFactory, Landlord, Account) ->
    $scope.submitTestDepositAnswers = (account, a, b) ->
      $scope.submittingTestDepositAnswers = true
      $http.post "#{RENTAPPLICATION_API_URL}#{account.resource_uri}verify/",
        test_deposit_answer_a: a
        test_deposit_answer_b: b
      .then ->
        $cacheFactory.get('$http').removeAll()
        Landlord.getMe().$promise.then (response) ->
          $scope.landlord = response
          if $scope.landlord.logo
            $scope.filename = $scope.landlord.logo
        Account.getMe({with_stripe_data:true}).$promise.then (response) ->
          $scope.account = response
      .catch (r) ->
        error_message = r.data.message or "Incorrect test deposit amounts. Please check your bank account again."
        Flash.create("danger", error_message , 3000, { class: 'error' }, true)
        
      .finally ->
        $scope.submittingTestDepositAnswers = false


// WEBPACK FOOTER //
// ./components/dashboard/settings/bank_account/bank_account.coffee